<template>
<div>

  <div class=" wow zoomIn" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: zoomIn;">
					<div class="feature_home">
						<div class="row">
           
                 <div class="col-auto align-self-center pr-3">
      <img src="/img/airlines/zv.png" width="50" height="50" />
    </div>

    		      <div class="row itinerary align-items-center">
        <div class="col-auto mb-2 text-center">
      
          <strong
            class="d-block text-truncate"
            style="font-size: 12px"
          >{{flight.originCity}} ({{flight.originIATA}})</strong>
           <span> {{flight.departureTime}}</span>
        </div>

        <img src="/img/departures.svg"  width="35" height="35" />
        <div class="col-auto mb-2 text-center">
         
          <strong
            class="d-block text-truncate"
            style="font-size: 12px"
          >{{flight.destinationCity}} ({{flight.destinationIATA}})</strong>
          <span> {{flight.arrivalTime}}</span>
        </div>
      
      </div>
      <!-- <label>{{flight.airLineTitle}}</label> -->
            </div>
			{{ flight.departureDateTimeShamsiText }}
     <hr>
					    <div class="col">
          
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
              <div class="icon icon-back-in-time"> </div>
              <span class="text-title">زمان پرواز :</span>
              
              <div style="    font-weight: 600;">{{ time }}</div>
              </div>
              </div>

                 <div class="col-md-6">
                   <div class="row">
              <div class="icon icon-ok-4"> </div>
              <span class="text-title">شماره پرواز :</span>
              
              <div style="font-weight: 600;">{{ flight.flightNumber }}</div>
              </div>
               </div>
              </div>
              
         
       
              <div class="row">
              <div style="margin-top: -4px; transform: rotate(310deg)" class="icon icon-plane"> </div>
              <span class="text-title">فرودگاه مبدا :</span>
              
              <div style="font-weight: 600;">{{flight.origin}}</div>
              </div>
         

              <div class="row">
              <div style="    margin-top: -7px !important;
    transform: rotate(240deg)" class="icon icon-plane"> </div>
              <span class="text-title">فرودگاه مقصد :</span>
              
              <div style="font-weight: 600;">{{flight.destination}}</div>
              </div>
              
        
            
          </div>

        <hr>
					<a  @click="$emit('selected', flight)" class="btn_outline">{{buttonTitle}}</a>
					</div>
				</div>

</div>
  
</template>

<script>
export default {
  name: "flight-time",
  props: {
    flight: Object,
    buttonTitle: {
      type: String,
      default: "عملیات",
    },
  },
  computed:{
    time(){
      const moment = require("moment");
      const dep = moment(this.flight.departureDateTime);
      const arr = moment(this.flight.arrivalDateTime);
      
      return moment(dep.diff(arr)).format("HH:mm");
    }
  }
};
</script>

<style  scoped>
.text-title {
      margin-right: 3px;
    display: flex;
    align-items: end;
    margin-left: 5px;
}
.itinerary{
  padding-left: 20%;
  padding-right: 20%;
}

/* .icon {
margin-bottom: 10px;
    display: block;
    width: 25px;
    height: 25px;
    font-size: 20px;
    color: #c4c9ce;
} */

.btn_outline {
    color: #0a6c9f !important;
    border: none;
    font-family: inherit;
    font-size: inherit;
    color: #008489;
    background: 0 0;
    border: 2px solid #0a6c9f;
    cursor: pointer;
    padding: 10px 20px;
    display: inline-block;
    outline: 0;
    font-size: 12px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    text-transform: uppercase;
    font-weight: 700;
    display: block;
    text-align: center;
}
</style>
